import LoadingIcon from '@images/loader-icon.svg?react'
import cn from 'classnames'
import { configuration } from 'mmfintech-backend-api'
import { getNetworkImageUrl } from 'mmfintech-commons'

import './CoreNetworkIcon.scss'

interface NetworkIconProps {
  network: string | undefined
  size?: string
  circle?: boolean
  className?: string
  isLoading?: boolean
}

export const CoreNetworkIcon = (props: NetworkIconProps) => {
  const { network, size = '3rem', circle, className, isLoading } = props

  return (
    <>
      {isLoading ? (
        <div className='network-icon-loading' style={{ width: size, height: size }}>
          <LoadingIcon />
        </div>
      ) : (
        <div
          style={{ width: size, minWidth: size, height: size }}
          className={cn('network-icon', className, { circle })}
        >
          <img src={findNetworkIconSrc(network)} alt='' />
        </div>
      )}
    </>
  )
}

export const findNetworkIconSrc = (network: string) =>
  `${configuration.getBaseUrl()}${getNetworkImageUrl(network, 'svg')}`
